import React, { useState } from "react";

const SearchBar = () => {
  const [searchTerm, setSearchTerm] = useState("");

  const handleSearch = (e) => {
    e.preventDefault();

    if (!searchTerm) return;

    const elements = document.querySelectorAll("body *:not(nav):not(nav *)");

    for (let element of elements) {
      if (
        element.childNodes.length > 0 &&
        element.childNodes[0].nodeType === Node.TEXT_NODE &&
        element.textContent.toLowerCase().includes(searchTerm.toLowerCase())
      ) {
        element.scrollIntoView({ behavior: "smooth", block: "center" });
        break;
      }
    }
  };

  return (
    <div className="bg-gray-200 dark:bg-gray-800 py-3">
      <div className="max-w-screen-xl mx-auto px-4">
        <form onSubmit={handleSearch} className="flex items-center space-x-2">
          <input
            type="text"
            placeholder="Search the page..."
            className="w-full px-4 py-2 rounded-md border border-gray-400 focus:outline-none focus:ring-2 focus:ring-yellow-500 dark:bg-gray-700 dark:text-white dark:border-gray-600"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <button
            type="submit"
            className="text-blue-900 bg-yellow-400 hover:bg-yellow-500 focus:ring-4 focus:outline-none focus:ring-yellow-300 font-medium rounded-lg text-sm px-4 py-2 text-center dark:text-gray-900 dark:bg-yellow-400 dark:hover:bg-yellow-500 dark:focus:ring-yellow-300"
          >
            Search
          </button>
        </form>
      </div>
    </div>
  );
};

export default SearchBar;
